import { useEffect, useState } from "react";
import { UseColumnDrawerProps } from "./types";

const useColumnDrawer = ({columns, onSave}: UseColumnDrawerProps) => {
  const [drawerColumns, setDrawerColumns] = useState(columns);

  useEffect(() => {
    setDrawerColumns(columns);
  }, [columns]);

  const onApply = () => {
    onSave(drawerColumns);
  }

  const onChangeCol = (key: string, checked: boolean) => {
    const col = drawerColumns?.map((data: any) => ({...data, checked: data.key == key ? checked : data.checked}));
    setDrawerColumns([...col]);
  }

  return {
    drawerColumns,
    onApply,
    onChangeCol
  }
}

export default useColumnDrawer;